<template>
  <v-container>
    <v-card>
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab v-for="item in items" :key="item.tab">
          {{ item.tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item class="settings-stack">
          <v-card flat>
            <v-form :disabled="!isEditBtn" ref="form" v-model="valid">
              <v-row class="mt-10" justify="center">
                <v-col cols="12" md="10">
                  <p class="font-weight-medium title ma-0">
                    {{
                      $vuetify.lang.t(
                        "$vuetify.main.psychologistDashboard.settings.aboutYou"
                      )
                    }}
                  </p>
                  <v-row>
                    <v-col md="3">
                      <p class="mt-5">
                        {{
                          $vuetify.lang.t(
                            "$vuetify.main.psychologistDashboard.settings.yourAvatar"
                          )
                        }}
                      </p>
                    </v-col>
                    <v-col md="8">
                      <ImageInput
                        :handleDisableInputByBufferPhoto="!this.isEditBtn"
                        :handle-change-avatar="handleChangeAvatar"
                        :getAvatarElement="getAvatarElement"
                      >
                        <v-avatar size="250"
                          ><img
                            id="img"
                            :class="{ avatar__grayscale: !this.isEditBtn }"
                            :alt="
                              $vuetify.lang.t(
                                `$vuetify.main.psychologistDashboard.settings.avatarAlt`
                              )
                            "
                          />
                        </v-avatar>
                      </ImageInput>
                      <span v-if="getWarningIfAvatarChange">
                        {{
                          $vuetify.lang.t(
                            "$vuetify.main.psychologistDashboard.settings.avatarDesc"
                          )
                        }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row class="pt-1 pb-0">
                    <v-col md="3" class="pt-0 pb-0">
                      <span class="mt-3">{{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.lastName"
                        )
                      }}</span>
                    </v-col>
                    <v-col md="4" class="pt-1 pb-0">
                      <v-text-field
                        v-model="psyhLastName.uk"
                        :rules="lastnameRules"
                        label="Прізвище"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="3" class="pt-1 pb-0">
                      <span class="mt-3">{{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.name"
                        )
                      }}</span>
                    </v-col>
                    <v-col md="4" class="pt-1 pb-0">
                      <v-text-field
                        v-model="psyhName.uk"
                        :rules="nameRules"
                        label="Ім'я"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="3" class="pt-1 pb-0">
                      <span class="mt-3">{{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.patronymic"
                        )
                      }}</span>
                    </v-col>
                    <v-col md="4" class="pt-1 pb-0">
                      <v-text-field
                        v-model="psyhPatronymic.uk"
                        :rules="[noRussianRule]"
                        label="По батькові"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="3">
                      <span class="mt-3">{{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.timezone"
                        )
                      }}</span>
                    </v-col>
                    <v-col md="8">
                      <TimeZOneInput
                        @new-time-zone="setNewTimeZOne"
                        :default-value="timezone"
                        :isOutlined="true"
                      ></TimeZOneInput>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="3">
                      <span class="mt-3">{{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.sex"
                        )
                      }}</span>
                    </v-col>
                    <v-col md="8">
                      <v-select
                        v-model="sex"
                        :items="sexList"
                        item-value="id"
                        item-text="title"
                        :label="
                          $vuetify.lang.t(
                            `$vuetify.main.psychologistReg.stepOne.sex`
                          )
                        "
                        dense
                        required
                        :rules="sexRules"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="3">
                      <span class="mt-3">{{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.howOld"
                        )
                      }}</span>
                    </v-col>
                    <v-col md="8">
                      <v-menu
                        v-model="datePickerMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            v-model="date"
                            :label="
                              $vuetify.lang.t(
                                `$vuetify.main.psychologistDashboard.settings.birthday`
                              )
                            "
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="{ keydown: on.keydown }"
                            @click.native="datePickerMenu = true"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          :active-picker.sync="birthdayPicker"
                          no-title
                          :max="maxBirthday"
                          min="1930-01-01"
                          locale="uk-UA"
                          :first-day-of-week="1"
                          @change="datePickerMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <v-row>
                    <p class="font-weight-medium title ma-0">
                      {{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.contacts"
                        )
                      }}
                    </p>
                  </v-row>

                  <v-row>
                    <v-col md="3">
                      <span class="mt-3">{{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.phone"
                        )
                      }}</span>
                    </v-col>
                    <v-col md="8">
                      <vue-phone-number-input
                        :disabled="!isEditBtn"
                        v-model="userPhoneNumber"
                        :default-country-code="defaultCountry"
                        :loader="hasLoaderActive"
                        :error="hasErrorActive"
                        :preferred-countries="countriesList"
                        :required="false"
                        @update="updatedData"
                        :translations="translations"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="3">
                      <span class="mt-3">{{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.email"
                        )
                      }}</span>
                    </v-col>
                    <v-col md="8">
                      <v-text-field
                        v-model="psyhEmail"
                        :rules="emailRules"
                        :label="
                          $vuetify.lang.t(
                            `$vuetify.main.psychologistDashboard.settings.emailLabel`
                          )
                        "
                        :placeholder="this.$store.getters['user/getUser'].email"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-end mb-10">
                    <v-btn
                      @click="validate('main')"
                      v-if="isEditBtn"
                      depressed
                      color="success"
                    >
                      {{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.save"
                        )
                      }}
                    </v-btn>

                    <v-btn
                      @click="isEditBtn = !isEditBtn"
                      v-if="!isEditBtn"
                      depressed
                      color="warning"
                    >
                      {{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.update"
                        )
                      }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
            
            <div class="social-logins-wrapper" v-if="!loginProviders || !loginProviders.length || !loginProviders.some(provider => provider.login_provider === 'google') || !loginProviders.some(provider => provider.login_provider === 'apple')">
              <!-- <p class="font-weight-medium text-center title ma-0">
                {{
                  $vuetify.lang.t(
                    "$vuetify.view.signIn.oldLoginLink1"
                  )
                }}
              </p> -->
              <div v-if="!loginProviders || !loginProviders.length || !loginProviders.some(provider => provider.login_provider === 'google')">
                <login-with-google :clickFunc="login" :isLinking="true" />
              </div>
              <div v-if="!loginProviders || !loginProviders.length || !loginProviders.some(provider => provider.login_provider === 'apple')">
                <login-with-apple :clickFunc="loginWithApple" :isLinking="true" />
              </div>
            </div>
          </v-card>
        </v-tab-item>

        <v-tab-item class="settings-stack">
          <v-card flat>
            <v-form
              :disabled="!isEditBtn"
              ref="form"
              v-model="valid"
              class="mt-5 px-5"
            >
              <v-row>
                <v-col md-3>
                  <p class="font-weight-bold mb-2">
                    {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.settings.aboutTitle") }}
                  </p>
                  <p class="mb-1">
                    {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.settings.aboutLead") }}
                  </p>
                  <ul class="mb-3">
                    <li v-for="n in 3" :key="n">
                      {{ $vuetify.lang.t(`$vuetify.main.psychologistDashboard.settings.aboutPoint${n}`) }}
                    </li>
                  </ul>
                  <p class="font-italic">
                    {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.settings.aboutNote") }}
                  </p>
                </v-col>
                <v-col md-6>
                  <v-textarea
                    :rules="[rules.required, noRussianRule, (v) => !v || v.length <= 2000 || 'Не більше 2000 символів']"
                    :counter="2000"
                    outlined
                    name="input-7-4"
                    label="Про себе"
                    v-model="aboutPsyh.uk"
                    rows="12"
                    class="settings-about-text"
                    :hint="$vuetify.lang.t('$vuetify.main.psychologistDashboard.settings.aboutResizeHint')"
                    persistent-hint
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <p class="font-weight-bold mb-2">
                    {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.settings.shortDescription") }}
                  </p>
                  <p class="mb-2">
                    {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.settings.shortDescriptionLead") }}
                  </p>
                  <p class="mb-3">
                    {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.settings.shortDescriptionNote") }}
                  </p>
                  <v-textarea
                    v-model="shortDescription"
                    outlined
                    rows="4"
                    auto-grow
                    :label="$vuetify.lang.t('$vuetify.main.psychologistDashboard.settings.shortDescription')"
                    :rules="shortDescriptionRules"
                    counter="300"
                  ></v-textarea>
                </v-col>
                <v-col md="6">
                  <span class="mt-3">{{
                    $vuetify.lang.t(
                      "$vuetify.main.psychologistDashboard.settings.video"
                    )
                  }}:</span>
                  <v-text-field
                    v-model="psyhVideo"
                    :label="
                      $vuetify.lang.t(
                        `$vuetify.main.psychologistDashboard.settings.videoLabel`
                      )
                    "
                    :placeholder="this.$store.getters['user/getUser'].video_source_url"
                    outlined
                    :hint="$vuetify.lang.t('$vuetify.main.psychologistDashboard.settings.videoHint')"
                    persistent-hint
                    class="mt-3"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>

            <div class="d-flex justify-end mb-10 mr-5">
              <v-btn
                @click="validate('about')"
                v-if="isEditBtn"
                depressed
                color="success"
              >
                {{
                  $vuetify.lang.t(
                    "$vuetify.main.psychologistDashboard.settings.save"
                  )
                }}
              </v-btn>

              <v-btn
                @click="isEditBtn = !isEditBtn"
                v-if="!isEditBtn"
                depressed
                color="warning"
              >
                {{
                  $vuetify.lang.t(
                    "$vuetify.main.psychologistDashboard.settings.update"
                  )
                }}
              </v-btn>
            </div>
          </v-card>
        </v-tab-item>

        <v-tab-item class="settings-stack">
          <v-card flat>
            <v-form :disabled="!isEditBtn" ref="form" v-model="valid">
              <v-row class="mt-10" justify="center">
                <v-col cols="12" md="10">
                  <!-- <v-row class="mt-0">
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="university"
                        :rules="universityRules"
                        :label="
                          $vuetify.lang.t(
                            `$vuetify.main.psychologistReg.stepOne.university`
                          )
                        "
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="faculty"
                        :rules="facultyRules"
                        :label="
                          $vuetify.lang.t(
                            `$vuetify.main.psychologistReg.stepOne.faculty`
                          )
                        "
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="speciality"
                        :rules="specialityRules"
                        :label="
                          $vuetify.lang.t(
                            `$vuetify.main.psychologistReg.stepOne.speciality`
                          )
                        "
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="scienceDegree"
                        :items="scienceDegreeList"
                        item-value="id"
                        item-text="title"
                        :label="
                          $vuetify.lang.t(
                            `$vuetify.main.psychologistReg.stepOne.scienseDegree`
                          )
                        "
                        dense
                        required
                        :rules="specialityRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="3" offset-md="2" class="mt-0 pt-0">
                      <v-text-field
                        v-model="yearOfEnding"
                        :rules="yearOfEndingRules"
                        :label="
                          $vuetify.lang.t(
                            `$vuetify.main.psychologistReg.stepOne.yearOfEnding`
                          )
                        "
                        :counter="4"
                        required
                        class="mt-0 pt-1"
                      ></v-text-field>
                    </v-col>
                  </v-row> -->

                  <div
                    v-for="(item, index) in educationItems"
                    :key="index"
                  >
                    <v-card class="mb-4">
                      <v-card-subtitle>
                        <div class="d-flex align-center">
                          <div class="flex-grow-1">
                            {{ $vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.education") }} №{{index + 1}}
                          </div>

                          <div class="ml-2">
                            <div>
                              <v-btn
                                icon
                                color="red"
                                class="ed-remove-btn"
                                @click="removeEdItem(index)"
                                :disabled="educationItems.length === 1 || !isEditBtn"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="2">
                            <v-text-field
                              v-model="item.year"
                              :label="
                                $vuetify.lang.t(
                                  `$vuetify.main.psychologistReg.stepOne.yearOfEnding`
                                )
                              "
                              type="text"
                              :rules="yearRules"
                              class="mt-0 pt-0"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="10">
                            <v-text-field
                              v-model="item.desc_uk"
                              label="Опис"
                              type="text"
                              :rules="descRulesUA"
                              class="mt-0 pt-0"
                            ></v-text-field>
                          </v-col>

                        </v-row>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div class="d-flex mt-2 mb-5">
                    <v-btn
                      color="primary"
                      @click="addEdItem"
                      :disabled="educationItems.length >= 20 || !isEditBtn"
                    >
                      {{ $vuetify.lang.t(`$vuetify.main.psychologistReg.stepOne.add_education`) }}
                    </v-btn>
                  </div>

                  <div class="d-flex justify-end mb-10 mt-5">
                    <v-btn
                      @click="validate('education')"
                      v-if="isEditBtn"
                      depressed
                      color="success"
                    >
                      {{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.save"
                        )
                      }}
                    </v-btn>

                    <v-btn
                      @click="isEditBtn = !isEditBtn"
                      v-if="!isEditBtn"
                      depressed
                      color="warning"
                    >
                      {{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.update"
                        )
                      }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-tab-item>

        <v-tab-item class="settings-stack">
          <v-card flat>
            <v-form
              :disabled="!isEditBtn"
              ref="form"
              v-model="valid"
              class="mt-5 px-5"
            >
              <v-row>
                <v-col md="6">
                  <p>
                    {{
                      $vuetify.lang.t(
                        "$vuetify.main.psychologistDashboard.settings.consultingExperience"
                      )
                    }}
                  </p>
                </v-col>
                <v-col md="2" cols="12">
                  <v-text-field
                    v-model="consultingExperience"
                    :rules="consultingExperienceRules"
                    required
                    :label="
                      $vuetify.lang.t(
                        `$vuetify.main.psychologistDashboard.settings.consultingExperienceLabel`
                      )
                    "
                    type="number"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col md="2">
                  <p>{{ consultingExperienceYearsText }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6" cols="12">
                  <p>
                    {{
                      $vuetify.lang.t(
                        "$vuetify.main.psychologistDashboard.settings.additionalProgram"
                      )
                    }}
                  </p>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    v-model="courses"
                    :rules="coursesRules"
                    required
                    :label="
                      $vuetify.lang.t(
                        `$vuetify.main.psychologistDashboard.settings.coursesLabel`
                      )
                    "
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md-3>
                  <p>
                    {{
                      $vuetify.lang.t(
                        "$vuetify.main.psychologistDashboard.settings.selfTherapy"
                      )
                    }}
                  </p>
                </v-col>
                <v-col md-6>
                  <v-row class="pt-4 pl-3">
                    <span class="justify-center">{{
                      $vuetify.lang.t(
                        "$vuetify.main.psychologistDashboard.settings.no"
                      )
                    }}</span>
                    <v-switch
                      v-model="selfPsychotherapy"
                      class="mt-0 pt-0 ml-2"
                    ></v-switch>
                    <span>{{
                      $vuetify.lang.t(
                        "$vuetify.main.psychologistDashboard.settings.yes"
                      )
                    }}</span>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col md-3>
                  <p>
                    {{
                      $vuetify.lang.t(
                        "$vuetify.main.psychologistDashboard.settings.regularSupervision"
                      )
                    }}
                  </p>
                </v-col>
                <v-col md-6>
                  <v-row class="pt-4 pl-3">
                    <span class="justify-center">{{
                      $vuetify.lang.t(
                        "$vuetify.main.psychologistDashboard.settings.no"
                      )
                    }}</span>
                    <v-switch
                      v-model="regularSupervision"
                      class="mt-0 pt-0 ml-2"
                    ></v-switch>
                    <span>{{
                      $vuetify.lang.t(
                        "$vuetify.main.psychologistDashboard.settings.yes"
                      )
                    }}</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>

            <div class="d-flex justify-end mb-10 mr-5">
              <v-btn
                @click="validate('experience')"
                v-if="isEditBtn"
                depressed
                color="success"
              >
                {{
                  $vuetify.lang.t(
                    "$vuetify.main.psychologistDashboard.settings.save"
                  )
                }}
              </v-btn>

              <v-btn
                @click="isEditBtn = !isEditBtn"
                v-if="!isEditBtn"
                depressed
                color="warning"
              >
                {{
                  $vuetify.lang.t(
                    "$vuetify.main.psychologistDashboard.settings.update"
                  )
                }}
              </v-btn>
            </div>
          </v-card>
        </v-tab-item>

        <v-tab-item class="settings-stack">
          <v-card flat>
            <v-form
              :disabled="!isEditBtn"
              ref="form"
              v-model="valid"
              class="mt-5 px-5"
            >
              <v-col>
                <v-row>
                  <v-col cols="12" md="3" offset-md="1">
                    <p>
                      {{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.yourCertificates"
                        )
                      }}
                    </p>
                    <p class="certificate-hint mb-0">
                      Позначте, які скани показувати в анкеті в блоці «Мої дипломи».
                    </p>
                  </v-col>

                  <v-col cols="12" md="2">
                    <v-btn
                      color="primary"
                      depressed
                      @click="handleCertificate"
                      small
                      >{{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.settings.uploadDoc"
                        )
                      }}
                    </v-btn>
                    <input
                      type="file"
                      hidden
                      ref="certificate"
                      @change="handleChangeCertificateInput"
                      multiple
                      accept="application/vnd.oasis.opendocument.text ,application/rtf, text/rtf, application/msword, application/pdf,image/png, image/jpg, image/jpeg"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="8" offset-md="4">
                    <v-sheet
                      v-if="this.newCertificates.length > 0"
                      elevation="3"
                      class="mb-8 border"
                    >
                      <v-row>
                        <v-col cols="12" md="8" offset-md="1">
                          <p
                            v-for="(newCertificate, i) in this.newCertificates"
                            :key="i"
                          >
                            {{ newCertificate.name }}
                            <v-btn @click="handleDeleteNewCertificates(i)" icon>
                              <v-icon class="icon-hover">mdi-close</v-icon>
                            </v-btn>
                          </p>
                        </v-col>
                      </v-row>
                      <v-row justify="center">
                        <v-col
                          cols="12"
                          md="4"
                          class="d-flex justify-space-around"
                        >
                          <v-btn
                            @click="handleClearAllNewCertificates"
                            small
                            depressed
                            color="warning"
                            class="mr-2"
                            >{{
                              $vuetify.lang.t(
                                "$vuetify.main.psychologistDashboard.settings.cancel"
                              )
                            }}
                          </v-btn>
                          <v-btn
                            @click="updatePsyhSettings('addCertificate')"
                            small
                            depressed
                            color="primary"
                            >{{
                              $vuetify.lang.t(
                                "$vuetify.main.psychologistDashboard.settings.accept"
                              )
                            }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </v-col>
                </v-row>

                <v-row class="pt-0">
                  <v-divider></v-divider>
                </v-row>
                <template v-for="(certificate, i) in this.certificates">
                  <v-row :key="i">
                    <v-col cols="12" md="3" offset-md="1">
                      <p class="align-self-center ma-0 pa-0">
                        {{ certificate.title }} {{ i + 1 }}
                      </p>
                    </v-col>
                    <v-col md="2">
                      <v-btn
                        :href="certificate.url"
                        target="_blank"
                        class="ma-0"
                        color="primary"
                        small
                        depressed
                        >{{
                          $vuetify.lang.t(
                            "$vuetify.main.psychologistDashboard.settings.download"
                          )
                        }}
                      </v-btn>
                    </v-col>
                    <v-col md="3">
                      <!-- "Мої дипломи" in the profile: a v-btn, so it works without the "Edit" mode of the form -->
                      <v-btn
                        v-if="certificate.can_be_public"
                        class="ma-0"
                        :color="certificate.public ? 'primary' : undefined"
                        :outlined="!certificate.public"
                        depressed
                        small
                        :loading="publicCertificateSaving === certificate.title"
                        @click="togglePublicCertificate(certificate)"
                      >
                        <v-icon left small>{{ certificate.public ? "mdi-eye" : "mdi-eye-off-outline" }}</v-icon>
                        {{ certificate.public ? "Показується в анкеті" : "Показувати в анкеті" }}
                      </v-btn>
                      <span v-else class="certificate-hint">На сайті показуються лише фото і PDF</span>
                    </v-col>
                    <v-col md="2">
                      <v-btn
                        class="ma-0"
                        color="warning"
                        depressed
                        small
                        @click="
                          updatePsyhSettings(
                            'deleteCertificate',
                            certificate.title
                          )
                        "
                        >{{
                          $vuetify.lang.t(
                            "$vuetify.main.psychologistDashboard.settings.delete"
                          )
                        }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-form>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <PublicPageSettings />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>

const LoginWithGoogle = () => import("@/components/UI/LoginWithGoogle");
const LoginWithApple = () => import("@/components/UI/LoginWithApple");
import { mapGetters } from "vuex";
import Vue from "vue";
import { hasRussianLetters, noRussianRule, NO_RUSSIAN_MESSAGE } from "@/utils/noRussian";

const TimeZOneInput = () => import("../../../components/UI/timeZoneInput");

const ImageInput = () => import("../../UI/ImageInput");
const PublicPageSettings = () => import("./PublicPageSettings");
export default {
  name: "Settings",
  components: {
    TimeZOneInput,
    ImageInput,
    LoginWithGoogle, 
    LoginWithApple,
    PublicPageSettings,
  },
  metaInfo() {
    return {
      title:
        "Платформа / " +
        this.$vuetify.lang.t("$vuetify.main.header.menu.settings"),
    };
  },
  data() {
    return {
      loginProviders: [],
      certificates: [],
      publicCertificateSaving: null,
      newCertificates: [],
      showAlertForNewAvatar: false,
      avatar: null,
      updatedAvatar: null,
      avatarElement: null,
      rules: {
        required: (value) =>
          !!value ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.rules"
          ),
      },
      tab: null,
      textAreaStep2: "",
      educationItems: [],
      items: [
        {
          tab: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.mainSettings"
          ),
        },
        {
          tab: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.aboutInfo"
          ),
        },
        {
          tab: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.education"
          ),
        },
        {
          tab: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.workExperience"
          ),
        },
        {
          tab: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.certificates"
          ),
        },
        {
          tab: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.publicPage.tab"
          ),
        },
      ],
      valid: false,
      psyhName: { ru: "", uk: "" },
      psyhLastName: { ru: "", uk: "" },
      psyhPatronymic: { ru: "", uk: "" },
      psyhEmail: "",
      priceSingles: null,
      priceCouples: null,
      psyhVideo: "",
      aboutPsyh: { ru: "", uk: "" },
      shortDescription: "",
      timezone: "",
      prevPayload: null,
      formatedDate: "",
      university: "",
      faculty: "",
      speciality: "",
      scienceDegree: [],
      sex: null,
      sexList: [
        {
          id: 0,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.female"
          ),
        },
        {
          id: 1,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.male"
          ),
        }
      ],
      yearOfEnding: "",
      date: "",
      dateTimePicker: "",
      datePickerMenu: false,
      birthdayPicker: null,
      experienceAges: "",
      courses: "",
      experienceWorkingOnline: "",
      selfPsychotherapy: false,
      regularSupervision: false,
      nameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.nameRules"
          ),
        noRussianRule,
      ],
      lastnameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.lastnameRules"
          ),
        noRussianRule,
      ],
      emailRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.emailRules1"
          ),
        (v) =>
          /.+@.+/.test(v) ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.emailRules2"
          ),
      ],
      consultingExperienceRules: [
        (v) =>
          !!+v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.consultingExperienceRules1"
          ),
        (v) =>
          (v && v >= 0) ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.consultingExperienceRules2"
          ),
        (v) =>
          (v && v <= 100) ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.consultingExperienceRules3"
          ),
      ],
      coursesRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.coursesRules1"
          ),
        (v) =>
          v.length >= 10 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.coursesRules2"
          ),
        noRussianRule,
      ],
      loader: null,
      loading: false,
      // Анкету психолог редагує одразу, без окремого режиму «Оновити»
      isEditBtn: true,
      consultingExperience: "",
      consultingExperienceYearsText: "",
      userPhoneNumber: null,
      defaultCountry: "",
      countriesList: ["UA", "RU", "BY", "MD"],
      translations: {
        countrySelectorLabel: this.$vuetify.lang.t(
          "$vuetify.main.psychologistDashboard.settings.countrySelectorLabel"
        ),
        countrySelectorError: this.$vuetify.lang.t(
          "$vuetify.main.psychologistDashboard.settings.countrySelectorError"
        ),
        phoneNumberLabel: this.$vuetify.lang.t(
          "$vuetify.main.psychologistDashboard.settings.phoneNumberLabel"
        ),
        example: this.$vuetify.lang.t(
          "$vuetify.main.psychologistDashboard.settings.example"
        ),
      },
      hasLoaderActive: false,
      hasErrorActive: false,
      userData: {},
      scienceDegreeList: [
        {
          id: "bachelors",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.bachelors"
          ),
        },
        {
          id: "master",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.master"
          ),
        },
        {
          id: "doctoral",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.doctoral"
          ),
        },
        {
          id: "candidate_of_sciences",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.candidate_of_sciences"
          ),
        },
      ],
    };
  },
  computed: {
    // the API accepts psychologists of 18 and older
    maxBirthday() {
      const d = new Date();
      d.setFullYear(d.getFullYear() - 18);
      return d.toISOString().substr(0, 10);
    },
    shortDescriptionRules() {
      return [
        (v) => !v || String(v).length <= 300 || this.$vuetify.lang.t("$vuetify.main.psychologistDashboard.settings.shortDescriptionTooLong"),
        noRussianRule,
      ];
    },
    ...mapGetters({
      user: "user/getUser",
    }),
    getUserAvatarLocalOrFromBuffer: function () {
      return this.user.buffer_photo ? this.user.buffer_photo : this.avatar;
    },
    getWarningIfAvatarChange: function () {
      return !!this.user.buffer_photo;
    },
    yearRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.yearRules1"
          ),
        (v) =>
          v.length === 4 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.yearRules2"
          ),
      ];
    },
    descRules() {
      return [(v) => !!v || this.$vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.descRules")];
    },
    descRulesUA() {
      return [(v) => !!v || this.$vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.descRulesUA"), noRussianRule];
    },
    universityRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.universityRules"
          ),
      ];
    },
    facultyRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.facultyRules"
          ),
      ];
    },
    specialityRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.specialityRules"
          ),
      ];
    },
    sexRules() {
      return [
        (v) =>
          (v === 0 || !!v) ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.sexRules"
          ),
      ];
    },
    yearOfEndingRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.yearOfEndingRules1"
          ),
        (v) =>
          v.length === 4 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.yearOfEndingRules2"
          ),
      ];
    },
  },
  watch: {
    // a birthday is picked year first, then month and day
    datePickerMenu(open) {
      open && setTimeout(() => (this.birthdayPicker = "YEAR"));
    },
    avatar() {
      if (this.avatarElement) {
        this.handleChangeAvatarView("watch");
      }
    },
    consultingExperience: function () {
      if (
        +this.consultingExperience === 11 ||
        +this.consultingExperience === 12 ||
        +this.consultingExperience === 13 ||
        +this.consultingExperience === 14
      ) {
        this.consultingExperienceYearsText = this.$vuetify.lang.t(
          "$vuetify.main.psychologistDashboard.settings.years"
        );
      } else if (this.consultingExperience % 10 === 1) {
        this.consultingExperienceYearsText = this.$vuetify.lang.t(
          "$vuetify.main.psychologistDashboard.settings.year"
        );
      } else if (
        this.consultingExperience % 10 === 2 ||
        this.consultingExperience % 10 === 3 ||
        this.consultingExperience % 10 === 4
      ) {
        this.consultingExperienceYearsText = this.$vuetify.lang.t(
          "$vuetify.main.psychologistDashboard.settings.years2"
        );
      } else {
        this.consultingExperienceYearsText = this.$vuetify.lang.t(
          "$vuetify.main.psychologistDashboard.settings.years"
        );
      }
    },
    user: function () {
      this.loadUser();
    },
  },
  mounted() {
    this.$store.dispatch("user/getProfile", {});
    this.loadUser();
  },
  methods: {
    noRussianRule,
    loginWithApple() {
      this.$store.commit("user/SET_PROCESS_LINKING_LOGIN", true);

      let base = process.env.VUE_APP_API.replace(/\/+$/, '');
      window.location.href = `${base}/api/auth/login/apple`;
    },
    login() {
      this.$store.commit("user/SET_PROCESS_LINKING_LOGIN", true);

      let base = process.env.VUE_APP_API.replace(/\/+$/, '');
      window.location.href = `${base}/api/auth/login/google`;
      /* window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_OAUTH2_CLIENT_ID,
        scope: "openid email profile",
        callback: (resp) => {
          let payload = {
            provider: 'google',
            token: resp.access_token,
          };
          this.loader = "loading";
          this.$store
            .dispatch('user/linkLogin', JSON.stringify(payload))
            // eslint-disable-next-line no-unused-vars
            .then((response) => {
              if (response.status === 200) {
                this.$router.go(0);
                Vue.swal({
                  target: document.getElementById("main"),
                  text: response.data.message,
                  icon: "success",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
                this.$store.commit("user/SET_ADMIN_TRIGGER", false);
              }
            })
            .catch((error) => {
              if (error instanceof TypeError) {
                Vue.swal({
                  target: document.getElementById("main"),
                  text: this.$vuetify.lang.t(
                    "$vuetify.view.restore.error"
                  ),
                  icon: "error",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
              }
              
              if (error.error === "user_exists") {
                Vue.swal({
                  target: document.getElementById("main"),
                  text: this.$vuetify.lang.t(
                    "$vuetify.view.restore.user_exists"
                  ),
                  icon: "error",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
              }
            })
            .finally(() => {
              this.loader = false;
            });
        }
      }).requestAccessToken(); */
    },
    addEdItem() {
      if (this.educationItems.length < 20) {
        this.educationItems.push({ year: "", desc_uk: "", desc_ru: "" });
      }
    },
    removeEdItem(index) {
      if (this.educationItems.length > 1) {
        this.educationItems.splice(index, 1);
      }
    },
    getAvatarElement() {
      this.avatarElement = document.getElementById("img");
      this.handleChangeAvatarView("mount");
    },
    handleChangeAvatarView(type) {
      if (type === "watch") {
        this.avatarElement.src = this.avatar;
      } else {
        this.avatarElement.src = this.getUserAvatarLocalOrFromBuffer;
      }
    },
    loadUser() {
      this.loginProviders = this.user.login_providers;
      this.educationItems = [];
      if (this.user.translated.education.ru && this.user.translated.education.uk) {
        this.user.translated.education.ru.forEach((edItem, index) => {
          if (this.user.translated.education.uk[index] && this.user.translated.education.uk[index].year == edItem.year) {
            this.educationItems.push({ 
              year: edItem.year, 
              desc_uk: this.user.translated.education.uk[index].desc,
              desc_ru: edItem.desc, 
            });
          }
        });
      }
      this.psyhName = this.user.translated.name;
      this.psyhLastName = this.user.translated.surname;
      this.psyhPatronymic = this.user.translated.middle_name || "";
      this.timezone = this.user.timezone;
      this.date = this.user.birthday;
      this.userPhoneNumber = this.user.phone;
      this.defaultCountry = this.user.phone_country_code;
      this.psyhEmail = this.user.email;
      this.priceSingles = this.user.price_singles;
      this.priceCouples = this.user.price_couples;
      this.psyhVideo = this.user.video_source_url;
      this.aboutPsyh = this.user.translated.about_info;
      this.shortDescription = this.user.short_description || "";
      this.consultingExperience = this.user.experience_ages;
      this.courses = this.user.courses;
      this.experienceWorkingOnline = this.user.experience_working_online;
      this.selfPsychotherapy = this.user.self_psychotherapy;
      this.regularSupervision = this.user.regular_supervision;
      this.avatar = this.user.buffer_photo
        ? this.user.buffer_photo
        : this.user.photo;
        
      this.sex = this.user.sex_value;

      this.certificates = this.user.certificates;
    },
    setNewTimeZOne(newTimeZone) {
      this.timezone = newTimeZone;
    },
    getPayload(from, titleDeleteCertificate) {
      let formData = new FormData();
      let phone = this.userData.formattedNumber;
      let countryCode = this.userData.countryCode;
      switch (from) {
        case "main":
          if (!phone) {
            phone = '';
          }
          if (!countryCode) {
            countryCode = '';
          }
          formData.append("phone", phone);
          formData.append("phone_country_code", countryCode);

          formData.append("email", this.psyhEmail);
          if (this.updatedAvatar) {
            formData.append("buffer_photo", this.updatedAvatar);
          }
          // eslint-disable-next-line no-case-declarations
          let profile = {
            profile: {
              // the platform is Ukrainian only, the API still keeps a ru copy of the texts
              name: { uk: this.psyhName.uk, ru: this.psyhName.uk },
              surname: { uk: this.psyhLastName.uk, ru: this.psyhLastName.uk },
              middle_name: {
                uk: this.psyhPatronymic.uk,
                ru: this.psyhPatronymic.uk,
              },
              birthday: this.date,
              sex: this.sex,
              timezone: this.timezone,
              price_singles: this.priceSingles,
              price_couples: this.priceCouples,
            },
          };
          // eslint-disable-next-line no-unreachable,no-case-declarations
          return this.buildFormData(formData, profile);
        case "about":
          return {
            profile: {
              video_source_url: this.psyhVideo,
              about_info: { uk: this.aboutPsyh.uk, ru: this.aboutPsyh.uk },
              short_description: (this.shortDescription || "").replace(/\s+/g, " ").trim() || null,
            },
          };
        case "education": {
          let educationItems_uk = [];
          let educationItems_ru = [];
          this.educationItems.forEach(educationItem => {
            educationItems_uk.push({
              year: educationItem.year,
              desc: educationItem.desc_uk,
            });
            educationItems_ru.push({
              year: educationItem.year,
              desc: educationItem.desc_uk,
            });
          });
          let education = {
            uk: educationItems_uk,
            ru: educationItems_ru,
          };

          return {
            profile: {
              education: education,
            },
          };
        }
        case "experience":
          return {
            profile: {
              experience_ages: this.consultingExperience,
              courses: this.courses,
              self_psychotherapy: this.selfPsychotherapy,
              regular_supervision: this.regularSupervision,
            },
          };
        case "addCertificate":
          return this.buildFormData(formData, {
            new_certificates: this.newCertificates,
          });
        case "deleteCertificate":
          return this.buildFormData(formData, {
            profile: {
              certificate_delete: titleDeleteCertificate,
            },
          });
      }
    },
    buildFormData(formData, data, parentKey) {
      if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
      ) {
        Object.keys(data).forEach((key) => {
          this.buildFormData(
            formData,
            data[key],
            parentKey ? `${parentKey}[${key}]` : key
          );
        });
      } else {
        const value = data == null ? "" : data;

        formData.append(parentKey, value);
      }
      if (this.newCertificates) {
        this.handleClearAllNewCertificates();
      }
      return formData;
    },
    async updatePsyhSettings(from, titleDeleteCertificate) {
      await this.$store
        .dispatch(
          "user/updateProfile",
          this.getPayload(from, titleDeleteCertificate)
        )
        .then((response) => {
          this.$store.commit("user/UPDATE_USER", response.data);
          Vue.swal({
            target: document.getElementById("main"),
            text: response.data.message,
            icon: "success",
            timer: 4000,
            toast: true,
            position: "top-right",
            showConfirmButton: false,
          });
          this.updatedAvatar = null;
        });
    },
    updatedData(data) {
      this.userData = data;
    },
    // texts of the section that is being saved
    sectionTexts(from) {
      switch (from) {
        case "main":
          return [this.psyhLastName.uk, this.psyhName.uk, this.psyhPatronymic.uk];
        case "about":
          return [this.aboutPsyh.uk, this.shortDescription];
        case "education":
          return this.educationItems.map((item) => item.desc_uk);
        case "experience":
          return [this.courses];
        default:
          return [];
      }
    },
    validate(from) {
      if (hasRussianLetters(this.sectionTexts(from))) {
        Vue.swal({
          target: document.getElementById("main"),
          text: NO_RUSSIAN_MESSAGE,
          icon: "error",
          timer: 7000,
          toast: true,
          position: "top-right",
          showConfirmButton: false,
        });
        return;
      }
      this.updatePsyhSettings(from);
    },
    handleChangeAvatar(e) {
      this.updatedAvatar = e.target.files[0];
      this.avatar = URL.createObjectURL(e.target.files[0]);
      this.showAlertForNewAvatar = true;
    },
    // shows / hides one scan in the profile ("Мої дипломи"); the server gets the whole list of shown names
    togglePublicCertificate(certificate) {
      const names = this.certificates
        .filter((item) => (item.title === certificate.title ? !item.public : item.public))
        .map((item) => item.title);
      this.publicCertificateSaving = certificate.title;
      this.$store
        .dispatch("user/updateProfile", { profile: { public_certificates: names } })
        .then((response) => {
          this.$store.commit("user/UPDATE_USER", response.data);
        })
        .finally(() => {
          this.publicCertificateSaving = null;
        });
    },
    handleCertificate() {
      this.$refs.certificate.click();
    },
    handleChangeCertificateInput(event) {
      this.newCertificates = [...event.target.files];
    },
    handleDeleteNewCertificates(index) {
      this.newCertificates.splice(index, 1);
    },
    handleClearAllNewCertificates() {
      this.newCertificates = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.certificate-hint {
  color: #868686;
  font-size: 13px;
}
/* phones: every label goes above its field instead of squeezing next to it
   (the "Публічна сторінка" tab has its own mobile layout) */
@media (max-width: 600px) {
  .settings-stack ::v-deep .row {
    margin-left: 0;
    margin-right: 0;
  }
  .settings-stack ::v-deep .row > [class*="col"] {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .settings-stack ::v-deep .row > [class*="col"]:first-child:not(:last-child) {
    padding-bottom: 0;
  }
  .settings-stack ::v-deep .row > p.title {
    padding: 0 12px;
    overflow-wrap: break-word;
  }
  .settings-stack ::v-deep .vue-phone-number-input {
    flex-wrap: nowrap;
    max-width: 100%;
  }
}
.social-logins-wrapper {
  max-width: 360px;
  padding: 10px 20px 40px;
  margin: 0 auto;
}
</style>
<style lang="sass" scoped>
.border
  border-radius: 8px
.icon-hover
  &:hover
    color: #e03939

.avatar__grayscale
  filter: grayscale(1)
</style>
